import React from "react";
import MuiSelect, { type SelectProps } from "@mui/material/Select";
import MuiMenuItem, { type MenuItemProps } from "@mui/material/MenuItem";

export type { SelectProps, MenuItemProps };

export function Select<Value = unknown>({ onClose, ...props }: SelectProps<Value>) {
  const handleClose: SelectProps<Value>["onClose"] = (e) => {
    onClose?.(e);
    // MUI keeps focus on the trigger after menu close — blur it
    // so the focused border style is removed.
    setTimeout(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  };

  return <MuiSelect onClose={handleClose} {...props} />;
}

export function MenuItem(props: MenuItemProps) {
  return <MuiMenuItem {...props} />;
}
